<script>
    import ElementDetails from '../Workspaces/ElementView/ElementDetails.svelte';
    import KeyPointTable from '../Workspaces/ElementView/KeyPointTable.svelte';
    import QuestionsTable from '../Workspaces/ElementView/QuestionsTable.svelte';
    import HazardControlTable from '../Workspaces/ElementView/HazardControlTable.svelte';
    import ToolTable from '../Workspaces/ElementView/ToolTable.svelte';
    import PartTable from '../Workspaces/ElementView/PartTable.svelte';
    import MaterialRisk from '../Workspaces/ElementView/MaterialRisk.svelte';
    import Section from '../common/Section.svelte';
    import {sgettext} from '../../i18n.js';
    import CorrectiveAction from '../Element/CorrectiveAction.svelte';
    import ReferenceDocumentTable from '../Workspaces/ElementView/ReferenceDocumentTable.svelte';
    import {
        readOnly
    } from './diffStore.js';

    export let count;
    export let elementDetails = null;
    export let sourceTemplateStatus = "";
    export let templateVersionNumber = 0;
    export let leftSide;
    export let showContextualFields = false;

</script>

<div class="wrapper">
  {#if elementDetails != null}
    {#if elementDetails.materialRisk}
      <MaterialRisk
        mechanism={elementDetails.materialRisk.mechanism}
        hazard={elementDetails.materialRisk.hazard}
        control={elementDetails.materialRisk.control}
        valid={elementDetails.materialRisk.valid}
      />
    {/if}
    <ElementDetails
      details={elementDetails}
      linkToEV={true}
      showVersions={false}
      {count}
      diffView={true}
      {leftSide}
      {templateVersionNumber}
      templateStatus={sourceTemplateStatus}
      contextualReadOnly={$readOnly}
      workspaceReadOnly={$readOnly}
      {sourceTemplateStatus}
      {showContextualFields}
    />
    <Section title={sgettext('$$RISKS_CONTROLS_1$$')}>
      <HazardControlTable rows={elementDetails.hazardscontrols} />
    </Section>
    {#if elementDetails.type === 'QUALITY' || elementDetails.type === 'SAFETY' || elementDetails.type === 'KNACK'}
      <Section title={sgettext('$$KEY_POINTS$$')}>
        <KeyPointTable rows={elementDetails.keypoints} />
      </Section>
    {/if}
    {#if elementDetails.type === 'QUALITY' || elementDetails.type === 'SAFETY'}
      <Section title={sgettext('$$QUESTIONS$$')}>
        <QuestionsTable rows={elementDetails.questions} />
      </Section>
    {/if}

    {#if elementDetails.type === 'TOOL'}
      <Section title={sgettext('$$TOOLS$$')}>
        <ToolTable rows={elementDetails.tools} />
      </Section>
    {/if}
    {#if elementDetails.type === 'PART'}
      <Section title={sgettext('$$PARTS$$')}>
        <PartTable rows={elementDetails.parts} />
      </Section>
    {/if}

    <Section title={sgettext('$$CORRECTIVE_ACTION$$')}>
      <CorrectiveAction model={elementDetails} />
    </Section>

    <Section title={sgettext('$$REFERENCE_DOCUMENTS$$')}>
      <ReferenceDocumentTable rows={elementDetails.reference_documents} />
    </Section>
  {/if}
</div>

<style>
  table {
    width: 100%;
  }

  th {
    vertical-align: top;
  }

  .details-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 15px;
  }

  @media (max-width: 1600px) {
    .details-row {
      grid-template-columns: 1fr;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
  }

  .wrapper > section {
    min-height: 150px;
    margin: 15px 5px;
  }
</style>
